import { render, staticRenderFns } from "./DetailDaftarEditGadai.vue?vue&type=template&id=584f78e6&"
import script from "./DetailDaftarEditGadai.vue?vue&type=script&lang=js&"
export * from "./DetailDaftarEditGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports